import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import apiCalls from '../utils/apiCalls';
import utils from '../utils/utils';

import GeneralForm from "../components/generalForm";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import MultiSelect from "../components/customFields/multiSelect";
import Loader from "../components/loader";

const MarketplaceAdminMarketplaceItemsForm = ({marketplace, history, intl}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [marketplaceItems, setMarketplaceItems] = useState([]);
  const [marketplaceItemOptions, setMarketplaceItemOptions] = useState([]);

  useEffect(() => {
    if (!marketplace) {
      return
    }

    apiCalls.getMarketplaceItems({
      marketplaceId: marketplace.id,
    })
      .then((result) => {
        setMarketplaceItemOptions(result.data.marketplaceItems);
        setMarketplaceItems(result.data.marketplaceItems.map(mi => mi.id));
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
      });
  }, [marketplace]);

  if (!marketplace) {
    return (<Loader show={loading}/>) ;
  }

  const options = marketplaceItemOptions.map(mi => {
    return {
      value: mi.id,
      label: `${mi.itemName} - #${mi.itemId}`,
    }
  });

  const formSchema = {
    type: "object",
    required: [],
    properties: {
      marketplaceItems: {
        type: "array",
        title: intl.formatMessage({id: 'marketplace.items.form.field.items.label'}),
        options,
      },
    }
  };

  const uiSchema = {
    marketplaceItems: {
      "ui:field": "multiSelect",
    },
  };

  function onFormSubmit() {
    setLoading(true);

    return apiCalls.editMarketplaceItems({
      marketplaceId: marketplace.id, marketplaceItems
    })
      .then((result) => {
        history.push(
          {
            pathname: `/marketplaceAdmin/${marketplace.id}/view`
          })
      })
      .catch((error) => {
        window.scrollTo(0, 0);
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(error, true));
      });
  }

  const formFields = {
    multiSelect: MultiSelect,
  };

  const header = intl.formatMessage({id: 'marketplace.items.edit.header'}, {marketplaceName: marketplace.name});

  return (
    <div className="row">
      <div className="col-12 col-lg-10 offset-lg-1 marketplace-admin__form">
        <GeneralForm title={header}
                     onChange={(event) => setMarketplaceItems(event.formData.marketplaceItems)}
                     onSubmit={onFormSubmit}

                     formSchema={formSchema}
                     formUiSchema={uiSchema}
                     formFields={formFields}

                     formData={{marketplaceItems}}

                     buttonCopy={'marketplace.items.edit.form.submit'}
                     errorMessage={error}
                     loading={loading}
                     hideImageUpload={true}
        />
      </div>
    </div>
  );
}

MarketplaceAdminMarketplaceItemsForm.propTypes = {
  currentUser: PropTypes.object,
  marketplace: PropTypes.object.isRequired,
};

MarketplaceAdminMarketplaceItemsForm.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
    marketplace: state.marketplace.marketplace,
  };
}

export default withRouter(injectIntl(connect(mapStateToProps)(MarketplaceAdminMarketplaceItemsForm)));